module.exports = __webpack_public_path__ + "static/media/biospherically-correct-trans-bg.ed09c6c1.png";